/**
 * @class
 * @description Wrapper class that injects our loader in a Bitmovin instance
 * @exports Bitmovin
 */
export default class Bitmovin {
    /**
     * Constructs Bitmovin adapter
     */
    constructor() {
        return {
            sendHttpRequest: new (Bitmovin._adapters.getLoaders().LoaderBitmovin)().sendHttpRequest
        };
    }
}
